<div fxLayout="row">
  <div fxFlex="93">
    <h2>{{ componentId + '.Title' | translate }}</h2>
  </div>
  <div fxFlex="7">
    <button mat-icon-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutGap="10px">
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>{{ componentId + '.FirstName' | translate }}</mat-label>
          <input matInput [placeholder]="componentId + '.FirstName' | translate" formControlName="firstName"
            maxlength="250" />
          </mat-form-field>
        </div>

        <div class="col-sm-12 col-md-6">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{ componentId + '.LastName' | translate }}</mat-label>
            <input matInput [placeholder]="componentId + '.LastName' | translate" formControlName="lastName"
              maxlength="250" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label>{{ componentId + '.Pesel' | translate }}</mat-label>
              <input matInput [placeholder]="componentId + '.Pesel' | translate" formControlName="pesel" maxlength="11" />
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ componentId + '.DateOfBirth' | translate }}</mat-label>
              <input matInput [matDatepicker]="birthDatePicker" formControlName="dateOfBirth"
                [matDatepickerFilter]="dateFilter" autocomplete="date" required />
                <mat-datepicker-toggle [for]="birthDatePicker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #birthDatePicker startView="multi-year" [startAt]="startDate"></mat-datepicker>
                @if (!dateOfBirthControl || (dateOfBirthControl.invalid && dateOfBirthControl.touched)) {
                  <mat-error>
                    {{ componentId + '.InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ componentId + '.Company' | translate }}</mat-label>
                <mat-select formControlName="company">
                  @for (company of listOfCompanies$ | async; track company) {
                    <mat-option #matOption [value]="company.Id">{{ company.Name
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ componentId + '.CompletingDeclarationDate' | translate }}</mat-label>
                <input matInput formControlName="completingDeclarationDate" disabled />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              @if (selectedCompany$ | async; as selectedCompany) {
                @if (selectedCompany.RequiredPPKSign) {
                  <app-signature-pad [label]="componentId + '.WorkerSignature' | translate"
                  [showClearButton]="true"></app-signature-pad>
                } @else {
                  <alert #alert class="info" [message]="componentId + '.PPKWithoutSign' | translate" alertType="info"></alert>
                }
              }
            </div>
          </div>
        </form>

        <div class="header-wrapper"></div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button mat-raised-button (click)="onClose()">
            {{ componentId + '.Cancel' | translate }}
          </button>
          @if (selectedCompany$ | async; as selectedCompany) {
            @if (selectedCompany.RequiredPPKSign) {
              <button mat-raised-button color="primary" (click)="submit()" [disabled]="formGroup.invalid || !isSignatureValid">
              {{ componentId + '.Generate' | translate }} </button>
            } @else {
              <button mat-raised-button color="primary" (click)="submit()" [disabled]="formGroup.invalid">
              {{ componentId + '.Confirm' | translate }} </button>
            }
          }
        </div>
      </div>